<script>
    import { storeName, frequency, next } from "../store/filters-recurring"
    import { recurring } from "../store/recurring";
    import { formatDate } from "../js/helper";
    import { filters } from "../store/filters-recurring"

    import { modal } from '../store/nav';


    export let filter;
    
    let options = [`All ${ filter == "storeName" ? "stores" : filter == "frequency" ? "schedules" : "dates" }`];

    const setFilter = selected => {
        if ( filter == `storeName` ) {
            if ( selected.option == "All stores"  ){ 
                storeName.set();
            }else{
                storeName.set(selected.option);
            }
        } else if ( filter == `frequency` ) {
            if ( selected.option == "All schedules"  ){ 
                frequency.set();
            }else{
                frequency.set(selected.option);
            }
        } else if ( filter == `next` ) { 
            if ( selected.option == "All dates"  ){ 
                next.set();
            }else{
                next.set(selected.option);
            }
        } else {
            console.log(`[ERROR] Cannot find a store for the selected filter`);
        }
        modal.close();
    };

    let recurringItems = $recurring; 
    for (const filter in $filters) {
        if ( $filters[filter] ){
            console.log(`Filter(s) applied:`,filter,$filters[filter]);
            recurringItems = recurringItems.filter( item => item[filter] == $filters[filter]);
        }
    }
    recurringItems.forEach(item => {
        let f = item[filter];
      
        if (!options.includes(f)) {
            options.push(f);
        }
        
        console.log(options);
    });
    console.log(options);
</script>

<section class="flex flex-col space-y-7 m-auto capitalize font-semibold text-primary">
    {#each options as option}
        <span on:click={()=>setFilter({option})}>{ typeof option === 'number' ? formatDate.md(option) : option}</span>
    {/each}
</section>